export const getColorLabel = (hex?: string): string | undefined => {
  if (!hex) return undefined;

  let value = hex.trim().toLowerCase();
  if (value.startsWith('#')) {
    value = value.slice(1);
  }

  if (value.length === 3) {
    value = value
      .split('')
      .map((c) => c + c)
      .join('');
  }

  if (!/^[0-9a-f]{6}$/.test(value)) {
    return 'Couleur personnalisée';
  }

  const r = parseInt(value.slice(0, 2), 16) / 255;
  const g = parseInt(value.slice(2, 4), 16) / 255;
  const b = parseInt(value.slice(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  h = (h * 360 + 360) % 360;

  const isGray =
    s < 0.15 ||
    (Math.abs(r - g) < 0.05 && Math.abs(g - b) < 0.05 && Math.abs(r - b) < 0.05);

  if (isGray) {
    if (l < 0.08) return 'Noir';
    if (l < 0.2) return 'Gris très foncé';
    if (l < 0.35) return 'Gris foncé';
    if (l < 0.6) return 'Gris';
    if (l < 0.8) return 'Gris clair';
    if (l < 0.93) return 'Blanc cassé';
    return 'Blanc';
  }

  let base: string;

  if (h < 15 || h >= 345) {
    base = 'Rouge';
  } else if (h < 30) {
    base = 'Orange';
  } else if (h < 50) {
    base = 'Jaune';
  } else if (h < 70) {
    base = 'Vert citron';
  } else if (h < 165) {
    base = 'Vert';
  } else if (h < 195) {
    base = 'Turquoise';
  } else if (h < 230) {
    base = 'Bleu';
  } else if (h < 260) {
    base = 'Indigo';
  } else if (h < 290) {
    base = 'Violet';
  } else if (h < 330) {
    base = 'Rose';
  } else {
    base = 'Rouge';
  }

  // Ajustement pour les bruns / beiges (entre orange et jaune, peu lumineux)
  if (h >= 20 && h <= 50 && l < 0.65) {
    if (l < 0.35) {
      base = 'Marron';
    } else if (l < 0.5) {
      base = 'Marron clair';
    } else {
      base = 'Beige';
    }
  }

  // Bleu très sombre → bleu marine
  if (base === 'Bleu' && l < 0.25) {
    base = 'Bleu marine';
  }

  let modifier = '';
  if (l < 0.18) {
    modifier = ' très foncé';
  } else if (l < 0.32) {
    modifier = ' foncé';
  } else if (l > 0.8) {
    modifier = ' très clair';
  } else if (l > 0.65) {
    modifier = ' clair';
  }

  return `${base}${modifier}`.trim();
};
